"use client";
import type { Dispatch, ReactElement, SetStateAction } from "react";
import type { GanttDependencyLineLayout } from "./gantt-render-selectors";
import type { GanttLayout } from "./gantt-types";
import { GanttDependencyLayer } from "./GanttDependencyLayer";
import { GanttGridLayer } from "./GanttGridLayer";
import { GanttHoverRowLayer } from "./GanttHoverRowLayer";
import { GanttSectionBackgroundLayer } from "./GanttSectionBackgroundLayer";
import { GanttSvgDefs } from "./GanttSvgDefs";
import { GanttTaskLayer } from "./GanttTaskLayer";
import { GanttTodayMarker } from "./GanttTodayMarker";
const GANTT_TIMELINE_CANVAS_NAME = "ganttTimelineCanvas";
export interface GanttTimelineSvgProps {
    ganttIdPrefix: string;
    layout: GanttLayout;
    hoveredTaskId: string | null;
    highlightedTaskIds: ReadonlySet<string>;
    dependencyLineLayouts: GanttDependencyLineLayout[];
    isEntranceComplete: boolean;
    onHoveredTaskIdChange: Dispatch<SetStateAction<string | null>>;
}
export function GanttTimelineSvg({ ganttIdPrefix, layout, hoveredTaskId, highlightedTaskIds, dependencyLineLayouts, isEntranceComplete, onHoveredTaskIdChange, }: GanttTimelineSvgProps): ReactElement {
    const timelineSvgDebugName = GANTT_TIMELINE_CANVAS_NAME;
    return (
      <svg data-el="Cmarkdowngantt/Timeline/Canvas" width={layout.timelineWidth} height={layout.chartHeight} viewBox={`0 0 ${layout.timelineWidth} ${layout.chartHeight}`}>
        <GanttSvgDefs ganttIdPrefix={ganttIdPrefix}/>
        <GanttGridLayer ganttIdPrefix={ganttIdPrefix} layout={layout}/>
        <GanttSectionBackgroundLayer ganttIdPrefix={ganttIdPrefix} layout={layout}/>
        <GanttHoverRowLayer ganttIdPrefix={ganttIdPrefix} layout={layout} hoveredTaskId={hoveredTaskId} highlightedTaskIds={highlightedTaskIds}/>
        <GanttDependencyLayer ganttIdPrefix={ganttIdPrefix} dependencyLineLayouts={dependencyLineLayouts}/>
        <GanttTaskLayer ganttIdPrefix={ganttIdPrefix} layout={layout} hoveredTaskId={hoveredTaskId} highlightedTaskIds={highlightedTaskIds} onHoveredTaskIdChange={onHoveredTaskIdChange}/>
        {layout.todayX != null && (<GanttTodayMarker ganttIdPrefix={ganttIdPrefix} todayX={layout.todayX} chartHeight={layout.chartHeight} isEntranceComplete={isEntranceComplete}/>)}
      </svg>
    );
}
